const SUPPORTING_PARTNERS = [
  {
    name: "Grace Hopper Celebration India 2027",
    logo: "/img/partners/ghci-2027-white.webp",
    href: "https://ghci.anitabindia.org/",
  },
];

function TierLabel({ tier, colorClass }) {
  return (
    <div className="flex items-center gap-3">
      <span className={`h-2 w-8 rounded-full ${colorClass}`} />
      <h3 className="font-display text-lg lg:text-xl font-semibold text-white">
        {tier}
      </h3>
    </div>
  );
}

export default function PartnersSponsors() {
  return (
    <>
      {/* Partners */}
      <section id="partners" className="relative py-24 border-t border-cyan-900/30 bg-[#050d1a]">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <div className="grid lg:grid-cols-12 gap-10 items-end">
            <div className="lg:col-span-7">
              <div className="mono text-[11px] uppercase tracking-[0.24em] text-cyan-300">
                06 · Partners
              </div>
              <h2 className="font-display mt-4 text-3xl lg:text-4xl font-bold text-white">
                Government, industry and knowledge partners.
              </h2>
            </div>
            <div className="lg:col-span-5">
              <p className="text-slate-400 leading-relaxed">
                Partner announcements to follow. Interested in becoming a
                partner? Please write to{" "}
                <a href="mailto:info@convex.events" className="text-cyan-300">
                  info@convex.events
                </a>
                .
              </p>
            </div>
          </div>

          {/* Supporting Partners */}
          <div className="mt-14">
            <div className="flex items-center gap-3 mb-6">
              <span className="h-2 w-8 rounded-full bg-gradient-to-r from-cyan-300 to-cyan-500" />
              <h3 className="font-display text-lg lg:text-xl font-semibold text-white">
                Supporting Partners
              </h3>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {SUPPORTING_PARTNERS.map((p) => {
                const Wrapper = p.href ? "a" : "div";
                const extra = p.href
                  ? { href: p.href, target: "_blank", rel: "noopener noreferrer" }
                  : {};
                return (
                  <Wrapper
                    key={p.name}
                    data-testid={`supporting-partner-${p.name
                      .toLowerCase()
                      .replace(/[^a-z0-9]+/g, "-")}`}
                    {...extra}
                    className="group aspect-[3/2] rounded-lg border border-cyan-500/30 bg-[#0B1120]/80 flex items-center justify-center p-6 hover:border-cyan-400/70 transition-colors"
                  >
                    <img
                      src={p.logo}
                      alt={p.name}
                      className="max-h-full max-w-full object-contain opacity-90 group-hover:opacity-100 transition-opacity"
                      loading="lazy"
                      decoding="async"
                    />
                  </Wrapper>
                );
              })}
            </div>
          </div>

          <div className="hairline mt-14" />
        </div>
      </section>
    </>
  );
}

// TierLabel kept for future sponsors section re-introduction
export { TierLabel };
